// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"ab6f94a2","277":"6f889ed6","385":"c3ee3b96"}[chunkId] + ".chunk.js";
};